import { ABTestConfig } from '../services/experimentService';

/**
 * A/B Test Configurations
 * 
 * Define all A/B tests here. 
 * The key should match the test name.
 */
export const abTestConfigs: Record<string, ABTestConfig> = {
  // NOTE: Intentionally empty for now.
  // We removed the value proposition intro A/B test to reduce onboarding complexity.
};

